<div class="breadcrumb-area">
	<h1>Margen de Utilidad</h1>
</div>
<div class="card mb-5">
	<div class="card-header">
		<h3>Administración de Margenes de Utilidad</h3>
	</div>
	<div class="card-body">
		<div class="form-group">
			<label for="pricelist" class="form-label">Lista de precios</label>
			<select name="pricelist" id="pricelist" (change)="changingPriceList()" [(ngModel)]="priceSelected"
				class="form-select">
				<option value="-1">Selecciona una lista de precios</option>
				<option *ngFor="let pricelist of pricelists" value="{{pricelist.id}}">{{pricelist.name}}</option>
			</select>
		</div>
		<ng-container *ngIf="categories.length > 0">
			<p class="text-muted">Para modificar un margen de utilidad, posicionate sobre el margen actual y presiona <i
					class="fa fa-edit"></i>, ingresa el nuevo margen y guardalo con presionar en el icono <i
					class="fa fa-save"></i></p>
			<div class="row">
				<div class="col">
					<div class="table table-responsive" style="margin-bottom: 0;">
						<table class="table" style="margin-bottom: 0;">
							<thead>
								<tr>
									<th>
										Nombre
									</th>
									<th>
										Descripción
									</th>
									<th>
										Subfamilias
									</th>
									<th class="td-center">
										Margen de Utilidad General
									</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let category of pagination.filter">
									<tr [class.tr-hide]="edit!=0 && edit!=category.id">
										<td>
											{{category.name}}
										</td>
										<td>
											<span *ngIf="category.description">
												{{category.description}}
											</span>
											<span *ngIf="!category.description" class="opacity-30">
												<i class="fa fa-circle-info"></i> Sin descripción.
											</span>
										</td>
										<td *ngIf="category.children.length == 0">
											<span class="opacity-30"><i class="fa fa-circle-info"></i> La familia no
												cuenta
												con
												subfamilias</span>
										</td>
										<td *ngIf="category.children.length > 0">


											<table class="table table-bordered table-subfamilies">
												<thead>
													<tr class="updown" *ngIf="category.children.length >0"
														(click)="categorySelected = categorySelected ==category.id?null:category.id">
														<th colspan="2">
															<span><i class="fa"
																	[ngClass]="category.id==categorySelected?'fa-chevron-up':'fa-chevron-down'"></i>{{category.id==categorySelected?'Comprimir':'Desplegar'}}
																{{category.children.length}} subfamilias</span>
														</th>
													</tr>
													<tr *ngIf="category.children.length == 0 && edit != category.id"
														style="font-size: 1em;border: none;">
														<th style="border: none;" colspan="2">
															<span class="opacity-30"><i class="fa fa-circle-info"></i>
																La
																familia no cuenta
																con
																subfamilias</span>
														</th>
													</tr>
													<tr
														*ngIf="categorySelected == category.id && category.children.length != 0">
														<th>
															Nombre
														</th>
														<th class="td-center">
															Porcentaje
														</th>
													</tr>
												</thead>
												<tbody *ngIf="categorySelected == category.id">
													<tr *ngFor="let child of category.children">
														<ng-container *ngIf="category.id!=edit">
															<td>
																{{child.name}}
															</td>
															<td class="td-center" style="max-width: 85px;min-width: 85px;">
																<span *ngIf="editSubfamily[child.id] == undefined"
																	(click)="editProfitSubfamily(child)"
																	class="profit-ammount">{{profits[child.id]}}%
																	<i class="fa fa-edit"></i></span>
																<div *ngIf="editSubfamily[child.id] != undefined"
																	class="input-group input-group-sm">
																	<label for="profit"
																		class="input-group-text">%</label>
																	<input type="number" name="profit"
																		style="text-align: center;"
																		[(ngModel)]="editSubfamily[child.id]"
																		id="profit" class="form-control" min="0">
																	<button class="btn btn-success"
																		[disabled]="profits[child.id] == editSubfamily[child.id] || editSubfamily[child.id] <= 0  || loading[category.id]"
																		(click)="saveProfitOfSingleCategory(child.id, editSubfamily[child.id])">
																		<ng-container *ngIf="!loading[child.id]">
																			<i class="fa fa-floppy-disk"></i>
																		</ng-container>
																		<ng-container *ngIf="loading[child.id]">
																			<span
																				class="spinner-border spinner-border-sm"
																				aria-hidden="true"></span>
																			<span role="status"></span>
																		</ng-container>
																	</button>
																</div>
															</td>
														</ng-container>
													</tr>
												</tbody>
											</table>
											<!-- <span class="updown"
												(click)="categorySelected = categorySelected ==category.id?null:category.id"><i
													class="fa"
													[ngClass]="category.id==categorySelected?'fa-chevron-up':'fa-chevron-down'"></i>{{category.id==categorySelected?'Comprimir':'Desplegar'}}
												subfamilias</span>
											<ul *ngIf="categorySelected == category.id">
												<li class="child-item" *ngFor="let child of category.children">
													<div class="profit-margin">
														<b>{{child.name}}:</b>
														<span *ngIf="editSubfamily[child.id] == undefined"
															(click)="editProfitSubfamily(child)"
															class="profit-ammount">{{profits[child.id]}}%
															<i class="fa fa-edit"></i></span>
														<div *ngIf="editSubfamily[child.id] != undefined"
															class="input-group input-group-sm">
															<label for="profit" class="input-group-text">%</label>
															<input type="number" name="profit"
																style="text-align: center;"
																[(ngModel)]="editSubfamily[child.id]" id="profit"
																class="form-control" min="0">
															<button class="btn btn-success"
																[disabled]="profits[child.id] == editSubfamily[child.id] || editSubfamily[child.id] <= 0  || loading[category.id]"
																(click)="saveProfitOfSingleCategory(child.id, editSubfamily[child.id])">
																<ng-container *ngIf="!loading[child.id]">
																	<i class="fa fa-floppy-disk"></i>
																</ng-container>
																<ng-container *ngIf="loading[child.id]">
																	<span class="spinner-border spinner-border-sm"
																		aria-hidden="true"></span>
																	<span role="status"></span>
																</ng-container>
															</button>
														</div>
													</div>
												</li>
											</ul> -->
										</td>
										<td class="ta">
											<div class="profit-margin">
												<span *ngIf="editFamily[category.id] == undefined"
													(click)="editProfitFamily(category)"
													class="profit-ammount">{{profits[category.id]}}% <i
														class="fa fa-edit"></i></span>
												<div *ngIf="editFamily[category.id] != undefined"
													class="input-group input-group-sm">
													<label for="profit" class="input-group-text">%</label>
													<input style="text-align: center;" type="number" name="profit"
														[(ngModel)]="editFamily[category.id]" id="profit"
														class="form-control" min="0">
													<button class="btn btn-success"
														[disabled]="profits[category.id] == editFamily[category.id] || editFamily[category.id] <= 0 || loading[category.id]"
														(click)="saveProfitOfSingleCategory(category.id, editFamily[category.id])">
														<ng-container *ngIf="!loading[category.id]">
															<i class="fa fa-floppy-disk"></i>
														</ng-container>
														<ng-container *ngIf="loading[category.id]">
															<span class="spinner-border spinner-border-sm"
																aria-hidden="true"></span>
															<span role="status"></span>
														</ng-container>
													</button>
												</div>
											</div>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
					<app-pagination-custom [elements]="pagination"></app-pagination-custom>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="priceSelected == -1">
			<p class="display-6" style="margin: 1em; text-align: center;"><i class="fa fa-circle-info"></i>Elige una
				lista de precios para continuar</p>
		</ng-container>
	</div>
</div>
<button class="btn btn-success btn-hide" (click)="saveAllProfits()" *ngIf="getShowSaveChanges()"
	[disabled]="getLoadingChanges()">
	<ng-container *ngIf="!savingAll">
		<i class="fa fa-floppy-disk"></i>
	</ng-container>
	<ng-container *ngIf="savingAll">
		<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
		<span role="status"></span>
	</ng-container>GUARDAR TODO
</button>